import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import HomePage from "./pages/HomePage";
import PlayerPage from "./pages/PlayerPage";
import TeamPage from "./pages/TeamPage";
import PlayersPage from "./pages/PlayersPage";
import LeaderboardPage from "./pages/LeaderboardPage";
import TeamsPage from "./pages/TeamsPage";
import PlayerStatsPage from "./pages/PlayerStatsPage";
import PlayerComparePage from "./pages/PlayerComparePage";
import StandingsPage from "./pages/Standings";
import SchedulePage from "./pages/Schedule";
import { Analytics } from "@vercel/analytics/react";

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-100">
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/player/:id" element={<PlayerPage />} />
          <Route path="/players" element={<PlayersPage />} />
          <Route path="/leaderboards" element={<LeaderboardPage />} />
          <Route path="/teams" element={<TeamsPage />} />
          <Route path="/team/:abbreviation" element={<TeamPage />} />
          <Route path="/playerStats" element={<PlayerStatsPage />} />
          <Route path="/PlayerCompare" element={<PlayerComparePage />} />
          <Route path="/Standings" element={<StandingsPage />} />
          <Route path="/Schedule" element={<SchedulePage />} />
        </Routes>
      </div>
      <Analytics />
    </Router>  
  );
}

export default App;